module.exports = __webpack_public_path__ + "static/desktop/img/photobook-1-thumb.a47c9ac3.png";